/*
  LynfaFlow — pixel della vetrina (versione VENDITA VERA, dal 2026-08-11).

  Dall'11 agosto 2026 il negozio vende davvero: Shopify Payments è attivo
  e il carrello/checkout sono quelli veri di Shopify. Questo file quindi
  NON intercetta più niente e NON dirotta più nessuno.

  Fa due sole cose:
  1. carica i pixel Meta e TikTok all'arrivo, tranne a chi ha già rifiutato;
  2. manda ViewContent quando si apre una pagina prodotto.

  DAL 14 AGOSTO 2026 I PIXEL PARTONO SUBITO. Prima aspettavano il consenso, e
  il risultato è stato che misuravano quanti accettavano i cookie invece di
  quanti arrivavano: sul sito WordPress, con lo stesso impianto, Meta vedeva
  113 arrivi su 610 clic. Scelta di Luca, allineata a quella del sito.
  Chi rifiuta viene rispettato in tutti e due i modi: se ha già rifiutato non
  si carica niente, e se rifiuta mentre è in pagina i pixel si spengono
  (revoca a Meta e TikTok, cookie _fbp/_fbc cancellati).
  La versione precedente sta accanto a questa, in
  Ecom/Negozio/tema-vendita-vera/assets__lynfaflow.2026-08-14-prima-pixel-sempre-attivo.js

  Gli eventi della cassa (AddPaymentInfo, Purchase) NON partono da qui:
  li manda il pixel personalizzato «Pixel Meta cassa LynfaFlow»
  (Shopify → Impostazioni → Eventi dei clienti). Non toccare quello.

  La versione precedente (checkout simulato: intercettava gli acquisti e
  dirottava su /pages/completa-ordine) è salvata in
  Ecom/Negozio/checkout-simulato/assets__lynfaflow.js
  Quella ancora prima (dirottamento sulla pagina "esaurito") è in
  Ecom/Negozio/tema-originali/assets__lynfaflow.js.pre-checkout-simulato

  La configurazione (ID pixel, dati del prodotto) arriva da
  snippets/lynfaflow.liquid dentro window.LynfaFlowConfig.

  Per vedere cosa fa, apri una pagina del sito aggiungendo ?lfdebug
  all'indirizzo e guarda la console del browser.
*/
(function () {
  'use strict';

  var CFG = window.LynfaFlowConfig || {};
  var DEBUG = location.search.indexOf('lfdebug') !== -1;

  function log() {
    if (!DEBUG) return;
    var a = Array.prototype.slice.call(arguments);
    a.unshift('[LynfaFlow]');
    console.log.apply(console, a);
  }

  // Un ID è valido solo se Luca lo ha davvero incollato.
  function idValido(id) {
    return typeof id === 'string' && id.length > 2 && id.indexOf('INSERISCI') === -1;
  }

  var metaAttivo = idValido(CFG.metaId);
  var tiktokAttivo = idValido(CFG.tiktokId);

  var coda = [];
  var pixelPronti = false;
  var spenti = false;   // diventa true se il visitatore rifiuta mentre è in pagina

  // Qui viaggia solo ViewContent: gli eventi del funnel partono dal sito
  // WordPress e dalla cassa Shopify, non dalla vetrina.
  function track(nome, params) {
    if (spenti) { log('pixel spenti dal visitatore: non mando', nome); return; }
    if (nome !== 'ViewContent') { log('evento non previsto in vetrina:', nome); return; }
    if (!pixelPronti) { coda.push([nome, params]); log('in coda:', nome); return; }
    params = params || {};
    if (metaAttivo && window.fbq) {
      try { window.fbq('track', 'ViewContent', params); } catch (e) { log('Meta ha dato errore:', e); }
    }
    if (tiktokAttivo && window.ttq) {
      try { window.ttq.track('ViewContent', params); } catch (e) { log('TikTok ha dato errore:', e); }
    }
    log('inviato:', nome, params);
  }

  /* ------------------------------------------------------------------ *
   * Caricamento dei pixel
   * ------------------------------------------------------------------ */
  function caricaMeta() {
    if (!metaAttivo || window.fbq) return;
    /* codice ufficiale Meta, non toccare */
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', CFG.metaId);
    window.fbq('track', 'PageView');
    log('pixel Meta caricato:', CFG.metaId);
  }

  function caricaTikTok() {
    if (!tiktokAttivo || window.ttq) return;
    /* codice ufficiale TikTok, non toccare */
    !function (w, d, t) {
      w.TiktokAnalyticsObject = t; var ttq = w[t] = w[t] || [];
      ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once',
        'ready', 'alias', 'group', 'enableCookie', 'disableCookie', 'holdConsent',
        'revokeConsent', 'grantConsent'];
      ttq.setAndDefer = function (t, e) {
        t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); };
      };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.instance = function (t) {
        var e = ttq._i[t] || [];
        for (var n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
        return e;
      };
      ttq.load = function (e, n) {
        var r = 'https://analytics.tiktok.com/i18n/pixel/events.js';
        ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = r;
        ttq._t = ttq._t || {}; ttq._t[e] = +new Date();
        ttq._o = ttq._o || {}; ttq._o[e] = n || {};
        var s = d.createElement('script');
        s.type = 'text/javascript'; s.async = !0; s.src = r + '?sdkid=' + e + '&lib=' + t;
        var a = d.getElementsByTagName('script')[0];
        a.parentNode.insertBefore(s, a);
      };
      ttq.load(CFG.tiktokId);
      ttq.page();
    }(window, document, 'ttq');
    log('pixel TikTok caricato:', CFG.tiktokId);
  }

  function avviaPixel() {
    if (pixelPronti) return;
    caricaMeta();
    caricaTikTok();
    pixelPronti = true;
    var attesa = coda.splice(0, coda.length);
    for (var i = 0; i < attesa.length; i++) track(attesa[i][0], attesa[i][1]);
  }

  /* ------------------------------------------------------------------ *
   * Consenso cookie
   *
   * Dal 14 agosto 2026 la regola è una sola: si parte, tranne con chi ha
   * già rifiutato. Prima si aspettava la risposta al banner, e chi non
   * rispondeva — la grande maggioranza — non veniva contato affatto.
   *
   *   'no'  → ha già rifiutato: non si carica niente
   *   tutto il resto ('si', 'aspetta', 'senza-banner') → si parte
   *
   * Il rifiuto dato mentre si è in pagina arriva con l'evento
   * visitorConsentCollected, e lì si spegne tutto.
   * ------------------------------------------------------------------ */
  function statoConsenso() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api) return 'senza-banner';
      if (typeof api.marketingAllowed === 'function' && api.marketingAllowed() === true) return 'si';
      if (typeof api.shouldShowBanner === 'function' && api.shouldShowBanner() === true) return 'aspetta';
      var scelta = typeof api.currentVisitorConsent === 'function' ? api.currentVisitorConsent() : null;
      if (scelta && (scelta.marketing === 'no' || scelta.analytics === 'no')) return 'no';
      return 'senza-banner';
    } catch (e) { return 'senza-banner'; }
  }

  // Il rifiuto va rispettato anche dopo: qui si revoca a Meta e a TikTok e si
  // cancellano i cookie con cui riconoscono la stessa persona.
  function spegniPixel() {
    if (spenti) return;
    spenti = true;
    try { if (window.fbq) window.fbq('consent', 'revoke'); } catch (e) { log('Meta:', e); }
    try {
      if (window.ttq && typeof window.ttq.revokeConsent === 'function') window.ttq.revokeConsent();
    } catch (e) { log('TikTok:', e); }
    try {
      var dom = location.hostname.replace(/^www\./, '');
      var morto = '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      ['_fbp', '_fbc'].forEach(function (k) {
        document.cookie = k + morto;
        document.cookie = k + morto + '; domain=.' + dom;
      });
    } catch (e) { log('cookie:', e); }
    log('pixel spenti su richiesta del visitatore');
  }

  function decidiSuiPixel() {
    if (pixelPronti || spenti) return;
    var stato = statoConsenso();
    log('consenso:', stato);
    if (stato === 'no') { log('ha già rifiutato in passato: non carico i pixel'); return; }
    avviaPixel();
  }

  document.addEventListener('visitorConsentCollected', function (ev) {
    var d = ev.detail || {};
    if (d.marketingAllowed || d.analyticsAllowed) {
      log('consenso raccolto adesso');
      avviaPixel();
      return;
    }
    log('rifiuto raccolto adesso');
    spegniPixel();
  });

  // Si aspetta l'API della privacy giusto il tempo di sapere se questo visitatore
  // aveva già rifiutato: è l'unica informazione per cui vale la pena aspettare.
  // Se non risponde entro un secondo e mezzo, si parte comunque — e se il rifiuto
  // salta fuori dopo, l'evento qui sopra spegne tutto.
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function () { decidiSuiPixel(); }
    );
    setTimeout(decidiSuiPixel, 1500);
  } else {
    decidiSuiPixel();
  }

  /* ------------------------------------------------------------------ *
   * Eventi di pagina
   * ------------------------------------------------------------------ */
  function datiProdotto() {
    var p = CFG.prodotto;
    if (!p) return {};
    return {
      content_type: 'product',
      content_ids: [String(p.id)],
      content_name: p.nome,
      value: p.prezzo,
      currency: p.valuta || 'EUR',
      num_items: 1
    };
  }

  if (CFG.template === 'product') track('ViewContent', datiProdotto());

  window.LynfaFlow = { track: track, config: CFG };
  log('pronto (vendita vera)', CFG);
})();
